// extracted by mini-css-extract-plugin
export default {"root":"fAG5rg","content":"g8VYqO","actions":"UW_ubC","hidden":"gEoLBQ","image":"EMiYvw","admin-badge":"qS4xoF","adminBadge":"qS4xoF","title":"lp69Ov","info":"JIqhgF"};